import { render, staticRenderFns } from "./InputLabel.component.vue?vue&type=template&id=654161f3"
import script from "./InputLabel.component.vue?vue&type=script&lang=js"
export * from "./InputLabel.component.vue?vue&type=script&lang=js"
import style0 from "./InputLabel.component.vue?vue&type=style&index=0&id=654161f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports